var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget_layout"},[_c('UserDefinedBanner'),_c('div',{staticClass:"layout_page_search"},[_c('div',{staticClass:"search_box"},[_c('PageSearch',{attrs:{"title":_vm.pageSearchTitle,"placeholder":_vm.pageSearchPlaceholder},on:{"update:value":_vm.onCheckPlugin}})],1)]),_c('div',{staticClass:"widget_slot"},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }